
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 27.54 15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M27.008 1.262c.508.508.762 1.093.762 1.758 0 .664-.254 1.25-.762 1.757-.508.47-1.094.703-1.758.703h-.059c-.273 0-.468-.02-.585-.058l-4.454 4.453c.078.234.117.45.117.645 0 .664-.253 1.25-.761 1.757-.508.47-1.094.704-1.758.704-.664 0-1.25-.235-1.758-.704-.508-.507-.762-1.093-.762-1.757 0-.196.04-.41.118-.645l-3.223-3.223c-.234.078-.45.118-.645.118s-.41-.04-.644-.118l-5.684 5.684c.078.234.118.45.118.644 0 .665-.254 1.25-.762 1.758s-1.094.762-1.758.762c-.664 0-1.25-.254-1.758-.762S.23 13.645.23 12.98c0-.664.254-1.23.762-1.699.508-.508 1.094-.761 1.758-.761.313 0 .527.02.645.058l5.683-5.683c-.039-.118-.058-.332-.058-.645 0-.664.234-1.25.703-1.758.507-.508 1.093-.762 1.757-.762.665 0 1.25.254 1.758.762S14 3.586 14 4.25c0 .313-.02.527-.059.645l3.164 3.164c.118-.04.332-.059.645-.059s.527.02.645.059l4.453-4.395a2.05 2.05 0 01-.117-.644c0-.665.253-1.25.761-1.758S24.586.5 25.25.5c.664 0 1.25.254 1.758.762z"}})])
          )
        }
      }
    